let cacheRTL = undefined;
export function isRTL() {
  return cacheRTL??(cacheRTL=document.body.matches('.rtl')?1:0)
}

